<template>
  <div class="login-container">
    <form
      class="form-signin"
      @submit.prevent="login"
    >
      <div class="col-12">
        <img
          src="../../assets/routa_light_S.png"
          style="display: block; margin-left: auto; margin-right: auto; width: auto; height: 6em; margin-bottom: 1em"
          alt="logo"
        >
      </div>
      <h2 class="form-signin-heading">
        Routa Infra
      </h2>
          <div class="input-group mb-1 mt-4">
            <input
                type="text"
                class="form-control"
                autocomplete="username"
                :placeholder="$t('login.username')"
                :aria-label="$t('login.username')"
                v-model="username">
        </div>
        <div class="input-group pt-1 mb-2">
            <input
                :type="showPassword ? 'text' : 'password'"
                class="form-control"
                :placeholder="$t('users.password')"
                :aria-label="$t('users.password')"
                v-model="password"
                autocomplete="current-password">
            <span class="input-group-text pointer" id="basic-addon2" @mousedown="showPassword = true"
                  @pointerdown="showPassword = true"
                  @pointerup="showPassword = false"
                  @mouseup="showPassword = false"
                  @mouseout="showPassword = false"><font-awesome-icon icon="eye" /></span>
        </div>

        <button
            type="submit"
            class="btn btn-success w-100 btn-md col-sm-12"
        >
            {{ $t('login.log_in') }}
        </button>
        <span class="d-inline-block forgot" @click.stop="$emit('resetPassword')">{{ $t('login.forgot_password') }}</span>
        <div class="row" v-if="externalMessage">
            <span style="font-size: .9em; color: #fff">{{ externalMessage }}</span>
        </div>
    </form>

    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {inject} from 'vue';

export default {
    name: 'Login',
    mixins: [restApi],
    props: {
        externalMessage: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            username: '',
            password: '',
            loading: false,
            showPassword: false,
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    mounted() {
        this.showPassword = false
    },
    methods: {
        async login() {
            this.loading = true
            const response = await this.axios.post(this.loginUrl, {
                username: this.username,
                password: this.password
            }).catch(() => this.fail())
            this.loading = false
            if (response && response.data && response.data.token) {
                this.$store.commit('storeToken', response.data.token)

                // set geodata - and geodatamap tokens to vuex store for later use
                const geoDataToken = response.data.geo_data_token ?? '';
                const geoDataMapToken = response.data.geo_data_map_token ?? '';

                this.$store.commit('storeGeoDataToken', geoDataToken)
                this.$store.commit('storeGeoDataMapToken', geoDataMapToken)

                // Read user prefs from backend
                await this.loadUserSettings();
                this.$emit('closeLoginForm')
            } else {
                this.fail()
            }
        },

        async loadUserSettings() {
            // Later other settings could be possible too, now we only have map settings
            try {
                const response = await this.fetchUserPreferences('mapSettings');
                const mapSettings = response && response.data.preferences;
                if (mapSettings) {
                    // Prepare settings for first use - remove observation and assignment details
                    if (mapSettings.buttons?.observations?.filters) {
                        mapSettings.buttons.observations.filters = null
                    }
                    if (mapSettings.buttons?.workAssignments?.filters) {
                        mapSettings.buttons.workAssignments.filters = null
                    }
                    this.$store.commit('storeMapSettings', mapSettings);
                }
            }
            catch (e) {
                const mapSettings = { baseMap: 'LEAFLET' };
                this.$store.commit('storeMapSettings', mapSettings);
            }
        },

        fail: function () {
            this.loading = false
            this.showAlert(this.$t('login.error'))
        },

        showResetTip: function () {
            this.showAlert(this.$t('login.reset_done'), 'info')
        }

    }
}
</script>
<style>
@import "../../styles/login.css";
::-ms-reveal {
    display: none;
}
</style>
